import AddIcon from "@mui/icons-material/Add";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import CloseIcon from "@mui/icons-material/Close";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import LoginIcon from "@mui/icons-material/Login";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import StarIcon from "@mui/icons-material/Star";
import VerifiedIcon from "@mui/icons-material/Verified";
import {
  Avatar,
  Box,
  Button,
  Chip,
  CircularProgress,
  IconButton,
  Modal,
  Stack,
  Typography
} from "@mui/material";
import { GoogleMap, Marker } from "@react-google-maps/api";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BIBlue, lightenHexColor } from "../../assets/helpers";
import mapMarkerYellow from "../../assets/images/marker_yellow.png";
import Loader from "../../common/Loader";
import {
  DELETE_USER_JOBPOSTING,
  GET_FOLLOW_COMPANIES,
  REPOST_USER_JOBPOSTING,
  SAVE_EXTERNAL_JOB,
  SAVE_FOLLOW_ENTITIES,
  SAVE_USERS_JOB_POSTS_NEW,
  UPDATE_VIEWS_FOR_JOB_POST
} from "../../constant/Apipath";
import { English } from "../../constant/EnglishFallback";
import { Postrequestcall } from "../../request/Postrequest";
import DeleteConfirmation from "../common/DeleteConfirmation";
import { getFormattedAddress } from "../common/GetFormattedAddress";
import ResumeList from "./ResumeList";
import { getExpiryLabel } from "./favoriteUtils";

const containerStyle = {
  width: "100%",
  height: "100%",
  borderRadius: "10px"
};

const formatJobType = (type) => {
  if (!type) return null;
  const map = {
    fulltime: "Full-Time",
    parttime: "Part-Time",
    contract: "Contract",
    FULLTIME: "Full-Time",
    PARTTIME: "Part-Time",
    CONTRACT: "Contract"
  };
  const normalizedType = String(type).trim().toUpperCase().replace(/[^A-Z]/g, "");
  return map[normalizedType] || type;
};

const getJobEmploymentType = (jobDetails = {}) =>
  jobDetails?.jobEmploymentType || jobDetails?.jobEmployementType || jobDetails?.jobType || "";

const getTradeItems = (trades = [], tradeNamesValue = "") => {
  if (Array.isArray(trades)) return trades;
  if (!trades) return [];

  const tradeNames = tradeNamesValue
    ? String(tradeNamesValue)
      .split(",")
      .map((name) => name.trim())
      .filter(Boolean)
    : [];

  return String(trades)
    .split(",")
    .map((trade) => trade.trim())
    .filter(Boolean)
    .map((trade, index) => ({
      id: trade,
      tradeName: tradeNames[index] || ""
    }));
};

const ViewJobPosting = (props) => {
  const {
    selectedJobDetails = {},
    open,
    onClose,
    jobApplied,
    from = "jobPostings",
    isFavorite,
    isFavoriteLoading,
    onFavoriteToggle
  } = props;
  const navigate = useNavigate();

  const { multiLanguageData, loginData } = useSelector((state) => state?.main);

  const userID = Number(loginData?.userInformation?.UserId || 0);

  const [companiesDetails, setCompaniesDetails] = useState(null);
  const [jobDetails, setJobDetails] = useState(selectedJobDetails);
  const [isLoading, setIsLoading] = useState(false);
  const [applyLoader, setApplyLoader] = useState(false);
  const [showConfirmationForWebiste, setShowConfirmationForWebiste] = useState(false);
  const [showResumeListModal, setShowResumeListModal] = useState(false);
  const [followLoader, setFollowLoader] = useState(false);
  const [deleteConfimationOpen, setDeleteConfirmationOpen] = useState(false);
  const [isRepostLoading, setIsRepostLoading] = useState(false);
  const [jobPostStatus, setJobPostStatus] = useState(selectedJobDetails?.isEx || false);
  const [showExternalApplyConfirmation, setShowExternalApplyConfirmation] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);

  const expiryLabel = getExpiryLabel(jobDetails?.jobPostExpiryDate);
  const employmentType = getJobEmploymentType(jobDetails);
  const isExternalJobDetails =
    jobDetails?.isExternal ||
    jobDetails?.mode?.toLowerCase() === "external" ||
    Boolean(jobDetails?.jobApplyLink);
  const jobTags = [
    ...(jobDetails?.jobPostTypes || []),
    ...getTradeItems(jobDetails?.trades, jobDetails?.tradeName || jobDetails?.TradeName || "")
  ];

  const LanguageData = multiLanguageData?.JobPostings || {};
  const {
    TEXT_DETAIL_MODAL_APPLY = English.JobPostings.TEXT_DETAIL_MODAL_APPLY,
    KM_AWAY = English.JobPostings.KM_AWAY,
    TEXT_DETAIL_MODAL_DURATION_KEY = English.JobPostings.TEXT_DETAIL_MODAL_DURATION_KEY,
    TEXT_DETAIL_MODAL_APPLIED_BTN = English.JobPostings.TEXT_DETAIL_MODAL_APPLIED_BTN,
    TEXT_DETAIL_MODAL_APPLY_BTN = English.JobPostings.TEXT_DETAIL_MODAL_APPLY_BTN,

    TEXT_JOB_DETAILS = English.JobPostings.TEXT_JOB_DETAILS,
    TEXT_DESCRIPTION = English.JobPostings.TEXT_DESCRIPTION,
    TEXT_NO_DESCRIPTION = English.JobPostings.TEXT_NO_DESCRIPTION,
    TEXT_COMPANY = English.JobPostings.TEXT_COMPANY,
    TEXT_FOLLOW = English.JobPostings.TEXT_FOLLOW,
    TEXT_FOLLOWING = English.JobPostings.TEXT_FOLLOWING,
    TEXT_NO_DESCRIPTION_AVAILABLE = English.JobPostings.TEXT_NO_DESCRIPTION_AVAILABLE,
    TEXT_YES_I_APPLIED = English.JobPostings.TEXT_YES_I_APPLIED,
    TEXT_DELETE_JOB_POSTING = English.JobPostings.TEXT_DELETE_JOB_POSTING,
    TEXT_DELETE_JOB_POST_CONFIRM = English.JobPostings.TEXT_DELETE_JOB_POST_CONFIRM,
    TEXT_YES = English.JobPostings.TEXT_YES,
    TEXT_NO = English.JobPostings.TEXT_NO,
    TEXT_EXPIRES = English.JobPostings.TEXT_EXPIRES,
    TEXT_VIA = English.JobPostings.TEXT_VIA,
    TEXT_SITE = English.JobPostings.TEXT_SITE,
    TEXT_INACTIVE = English.JobPostings.TEXT_INACTIVE,
    TEXT_ACTIVE = English.JobPostings.TEXT_ACTIVE,
    TEXT_ALREADY_APPLIED = English.JobPostings.TEXT_ALREADY_APPLIED,
    TEXT_DID_YOU_APPLY = English.JobPostings.TEXT_DID_YOU_APPLY,
    TEXT_APPLY_NOW = English.JobPostings.TEXT_APPLY_NOW,
    TEXT_DELETE = English.JobPostings.TEXT_DELETE,
    TEXT_REPOST = English.JobPostings.TEXT_REPOST,
    TEXT_APPLIED = English.JobPostings.TEXT_APPLIED,
    TEXT_APPLY_ON_WEBSITE = English.JobPostings.TEXT_APPLY_ON_WEBSITE,
    TEXT_APPLY = English.JobPostings.TEXT_APPLY
  } = LanguageData || {};

  useEffect(() => {
    if (jobDetails?.companyId) {
      fetchCompaniesDetails(jobDetails?.companyId);
    }
  }, [jobDetails?.companyId]);

  useEffect(() => {
    // Only update view count for internal jobs, not external jobs
    if (from === "jobPostings" && !isExternalJobDetails) {
      const payload = {
        JobPostId: jobDetails?.id,
        UserId: userID
      };
      Postrequestcall(UPDATE_VIEWS_FOR_JOB_POST, payload, loginData?.accessToken);
    }
  }, [jobDetails?.id, from]);

  const fetchCompaniesDetails = async (companyId) => {
    try {
      setFollowLoader(true);
      let obj = {
        UserId: userID,
        CompanyId: companyId
      };
      const res = await Postrequestcall(GET_FOLLOW_COMPANIES, obj, loginData?.accessToken);
      setCompaniesDetails(res?.data?.data?.[0] || null);
    } catch (error) {
      console.log("Error :: fetchCompaniesDetails :: ", error);
    } finally {
      setFollowLoader(false);
    }
  };

  const onApplyOnWebsite = () => {
    let url = jobDetails?.receiveApplicantLink;
    setShowConfirmationForWebiste(true);
    // Add protocol if missing
    if (url && !url.startsWith("http://") && !url.startsWith("https://")) {
      url = "https://" + url;
    }

    window.open(url, "_blank");
  };

  const onSiteClick = (site) => {
    navigate(`/sites`, {
      state: {
        site: { ...site, siteId: site?.id }
      }
    });
  };

  const onCompanyClick = (companyId) => {
    navigate(`/company/${companyId}`);
  };

  const onApplyClick = () => {
    setShowResumeListModal(true);
  };

  const onJobAppliedSucess = () => {
    jobApplied(jobDetails?.id);
    setJobDetails((prev) => ({ ...prev, isApplied: true }));
  };

  const onYesClick = async () => {
    try {
      setApplyLoader(true);
      let obj = {
        UserId: userID,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            JobPostId: jobDetails?.id,
            UserId: userID,
            ModifiedBy: userID
          }
        ]
      };
      const res = await Postrequestcall(SAVE_USERS_JOB_POSTS_NEW, obj, loginData?.accessToken);
      onJobAppliedSucess();
    } catch (error) {
      console.log("Error :: fetchCompaniesDetails :: ", error);
    } finally {
      setApplyLoader(false);
    }
  };

  const onFollowCompany = async () => {
    try {
      if (followLoader) return;
      setFollowLoader(true);
      const obj = {
        UserId: userID,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: companiesDetails?.followingId || 0,
            EntityTypeId: 8,
            EntityId: jobDetails?.companyId || 0,
            UserId: userID,
            IsFollowing: companiesDetails?.isFollowing ? false : true,
            ModifiedBy: userID
          }
        ]
      };
      const res = await Postrequestcall(SAVE_FOLLOW_ENTITIES, obj, loginData?.accessToken);
      setCompaniesDetails((prev) => ({
        ...prev,
        isFollowing: !prev?.isFollowing,
        followingId: res?.data?.data?.[0]?.objData?.id || prev?.followingId
      }));
    } catch (error) {
      console.log("Error :: ", error);
    } finally {
      setFollowLoader(false);
    }
  };

  const onDeleteClick = async () => {
    try {
      const payload = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: false,
        ReturnRecordError: true,
        DeleteList: [
          {
            Id: jobDetails?.id || 0
          }
        ]
      };
      const response = await Postrequestcall(
        DELETE_USER_JOBPOSTING,
        payload,
        loginData?.accessToken
      );
      if (response.status == 200 || response.data.status) {
        onClose();
        props.onJobDeleted && props.onJobDeleted(jobDetails?.id);
      }
    } catch (error) {
      console.log("Error :: onDelteClick :: ", error);
    }
  };

  const onRepostClick = async () => {
    try {
      setIsRepostLoading(true);
      let payload = {
        JobPostId: jobDetails?.id
      };
      const response = await Postrequestcall(
        REPOST_USER_JOBPOSTING,
        payload,
        loginData?.accessToken
      );
      console.log("response", JSON.stringify(response, null, 2));
      if (response.status == 200 || response.data.status) {
        setJobPostStatus(false);
        if (props.onJobReposted) {
          props.onJobReposted(jobDetails);
        }
      }
    } catch (error) {
      console.log("Error :: onRepostClick :: ", error);
    } finally {
      setIsRepostLoading(false);
    }
  };

  const onSaveExternalJob = async () => {
    setSaveLoading(true);
    try {
      const payload = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            JobId: jobDetails?.jobId || jobDetails?.id,
            UserId: loginData?.userInformation?.UserId,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      const res = await Postrequestcall(SAVE_EXTERNAL_JOB, payload, loginData?.accessToken);
      if (res?.status === 200 || res?.status === 201) {
        if (jobApplied) {
          jobApplied(jobDetails?.id);
        }
        onClose();
      }
    } catch (error) {
      console.log("Error onSaveExternalJob :: ", error);
    } finally {
      setSaveLoading(false);
    }
  };

  const getSiteAddress = (params) => {
    const siteAddress = {
      city: params?.city,
      country: params?.country,
      province: params?.province,
      postalCode: params?.postalCode,
      address: params?.address
    };
    let { city, country, province, postalCode, address, address1 } = siteAddress ? siteAddress : {};
    city =
      city !== "" && city
        ? city.replace(/\w*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
        : "";
    country =
      country !== "" && country
        ? country.replace(
          /\w*/g,
          (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        )
        : "";

    const uAddress = getFormattedAddress(
      address ?? "",
      address1 ?? "",
      city ?? "",
      province ?? "",
      country ?? "",
      postalCode ?? "",
      3
    );
    return uAddress;
  };

  const redirectToExternalCompanies = (jobDetails) => {
    if (jobDetails?.employerWebsite === "" || jobDetails?.employerWebsite === null) {
      alert(jobDetails?.companyName + " " + "Company is not listed in our BuildID.");
    } else {
      window.open(jobDetails?.employerWebsite);
    }
  };

  // const renderSiteSection = () => {
  //   const site = jobDetails?.site;
  //   console.log('ssssssssssssssss ',jobDetails)
  //   if (!site?.id) return null;
  //   return (
  //     <Stack sx={{ mt: 2 }}>
  //       <Typography sx={{ color: "text.secondary" }} variant="body2">
  //         {TEXT_SITE}
  //       </Typography>
  //       <Stack sx={{ border: "1px solid #ccc", borderRadius: 2, mt: 1 }}>
  //         <Stack sx={{ alignItems: "center", justifyContent: "space-between", pr: 1, pl: 1, mt: 1 }} // direction={"row"} // // //>
  //           <Stack>
  //             <Typography variant="h5" sx={{ fontSize: 16 }}>
  //               {site?.name}
  //             </Typography>
  //             <Typography sx={{ color: "text.secondary" }} variant="body2">
  //               {getSiteAddress(site)}
  //             </Typography>
  //           </Stack>
  //           <IconButton onClick={() => onSiteClick(site)}>
  //             <KeyboardArrowRightIcon />
  //           </IconButton>
  //         </Stack>
  //         <Box sx={{ height: "250px", pt: 1 }}>
  //           <GoogleMap
  //             options={{
  //               disableDefaultUI: false,
  //               fullscreenControl: false,
  //               mapTypeControl: false,
  //               streetViewControl: false,
  //               zoomControl: false,
  //               draggable: false,
  //               keyboardShortcuts: false,
  //               styles: [
  //                 {
  //                   featureType: "poi",
  //                   elementType: "all",
  //                   stylers: [{ visibility: "off" }]
  //                 },
  //                 {
  //                   featureType: "transit",
  //                   elementType: "all",
  //                   stylers: [{ visibility: "off" }]
  //                 },
  //                 {
  //                   featureType: "road",
  //                   elementType: "labels.icon",
  //                   stylers: [{ visibility: "off" }]
  //                 }
  //               ]
  //             }}
  //             center={{
  //               lat: site?.latitude,
  //               lng: site?.longitude
  //             }}
  //             zoom={13}
  //             mapContainerStyle={containerStyle}>
  //             <Marker
  //               position={{
  //                 lat: site?.latitude,
  //                 lng: site?.longitude
  //               }}
  //               icon={{
  //                 url: mapMarkerYellow,
  //                 scaledSize: new window.google.maps.Size(30, 40)
  //               }}
  //             />
  //           </GoogleMap>
  //         </Box>
  //       </Stack>
  //     </Stack>
  //   );
  // };

  const renderSiteSection = () => {
    // const site = jobDetails?.site;
    const site = {
      id: jobDetails?.siteId,
      name: jobDetails?.siteName,
    }
    if (!site?.id) return null;
    return (
      <Stack sx={{ mt: 2 }}>
        <Typography sx={{ color: "text.secondary" }} variant="body2">
          {TEXT_SITE}
        </Typography>
        <Stack sx={{ border: "1px solid #ccc", borderRadius: 2, mt: 1 }}>
          <Stack sx={{ alignItems: "center", justifyContent: "space-between", pr: 1, pl: 1, mt: 1 }} direction={"row"}>
            <Stack>
              <Typography variant="h5" sx={{ fontSize: 16 }}>
                {site?.name}
              </Typography>
              <Typography sx={{ color: "text.secondary" }} variant="body2">
                {getSiteAddress(jobDetails?.siteAddress)}
              </Typography>
            </Stack>
            <IconButton onClick={() => onSiteClick(site)}>
              <KeyboardArrowRightIcon />
            </IconButton>
          </Stack>
          {jobDetails?.siteAddress &&
            <Box sx={{ height: "250px", pt: 1 }}>
              <GoogleMap
                options={{
                  disableDefaultUI: false,
                  fullscreenControl: false,
                  mapTypeControl: false,
                  streetViewControl: false,
                  zoomControl: false,
                  draggable: false,
                  keyboardShortcuts: false,
                  styles: [
                    {
                      featureType: "poi",
                      elementType: "all",
                      stylers: [{ visibility: "off" }]
                    },
                    {
                      featureType: "transit",
                      elementType: "all",
                      stylers: [{ visibility: "off" }]
                    },
                    {
                      featureType: "road",
                      elementType: "labels.icon",
                      stylers: [{ visibility: "off" }]
                    }
                  ]
                }}
                center={{
                  lat: site?.latitude,
                  lng: site?.longitude
                }}
                zoom={13}
                mapContainerStyle={containerStyle}>
                <Marker
                  position={{
                    lat: site?.latitude,
                    lng: site?.longitude
                  }}
                  icon={{
                    url: mapMarkerYellow,
                    scaledSize: new window.google.maps.Size(30, 40)
                  }}
                />
              </GoogleMap>
            </Box>}
        </Stack>
      </Stack>
    );
  };
  const renderCompanySection = () => {
    if (!jobDetails?.companyId) return null;
    return (
      <Stack sx={{ mt: 2 }}>
        <Typography sx={{ color: "text.secondary" }} variant="body2">
          {TEXT_COMPANY}
        </Typography>
        <Stack sx={{ border: "1px solid #ccc",
            borderRadius: 2,
            mt: 1,
            pr: 2,
            pl: 2,
            pt: 1,
            pb: 1, alignItems: "center", justifyContent: "space-between" }} direction="row">
          <Stack sx={{ gap: 1,  alignItems: "center", justifyContent: "center", cursor: "pointer"  }} direction="row"  onClick={() => onCompanyClick(jobDetails?.companyId)}>
            {Boolean(companiesDetails?.companyLogo) && (
              <Avatar
                src={companiesDetails?.companyLogo}
                alt={jobDetails?.companyName || "Company"}
                style={{ width: 40, height: 40 }}
              />
            )}
            <Typography variant="h5" sx={{ fontSize: 16 }}>
              {jobDetails?.companyName}
            </Typography>
            {companiesDetails?.verified && <VerifiedIcon sx={{ color: "#42a2f1", fontSize: 15 }} />}
          </Stack>
          <Button
            startIcon={!companiesDetails?.isFollowing ? followLoader ? null : <AddIcon /> : null}
            size="large"
            variant="outlined"
            sx={{ textTransform: "none" }}
            onClick={onFollowCompany}>
            {followLoader ? (
              <CircularProgress sx={{ color: BIBlue }} size={22} />
            ) : companiesDetails?.isFollowing ? (
              TEXT_FOLLOWING
            ) : (
              TEXT_FOLLOW
            )}
          </Button>
        </Stack>
      </Stack>
    );
  };

  const renderExternalCompanyCard = () => {
    if (!(jobDetails?.companyName || jobDetails?.employerName)) return null;
    return (
      <Stack sx={{ mt: 2 }}>
        <Typography sx={{ color: "text.secondary" }} variant="body2">
          {TEXT_COMPANY}
        </Typography>
        <Stack sx={{ gap: 1.5,  alignItems: "center", border: "1px solid #ccc", borderRadius: 2, mt: 1, p: 1.5, cursor: "pointer"  }} direction="row"  onClick={() => redirectToExternalCompanies(jobDetails)}>
          <Avatar
            src={jobDetails?.companyProfilePicture || jobDetails?.employerLogo || ""}
            alt={jobDetails?.companyName || jobDetails?.employerName}
            variant="rounded"
            sx={{
              width: 50,
              height: 50,
              bgcolor: lightenHexColor(BIBlue, 90),
              borderRadius: 1.25
            }}>
            {!(jobDetails?.companyProfilePicture || jobDetails?.employerLogo) && (
              <BusinessCenterIcon sx={{ color: BIBlue, fontSize: 25 }} />
            )}
          </Avatar>
          <Typography variant="body1" sx={{ fontWeight: 600, flex: 1 }} noWrap>
            {jobDetails?.companyName || jobDetails?.employerName}
          </Typography>
        </Stack>
      </Stack>
    );
  };

  return (
    <>
      <Modal open={open}>
        <Box
          className="user-modal-responsive"
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            maxHeight: "90vh",
            overflow: "hidden"
          }}>
          {/* Modal Header */}
          <Stack sx={{ alignItems: "center", justifyContent: "space-between", position: "sticky",
              top: 0,
              backgroundColor: "white",
              zIndex: 10,
              px: 2,
              py: 1,
              borderBottom: "1px solid #f0f0f0" }} direction="row">
            <Typography variant="h6" sx={{ fontWeight: 700, fontSize: "1rem", color: "#333" }}>
              {TEXT_JOB_DETAILS}
            </Typography>
            <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
              <IconButton
                size="small"
                onClick={(event) => onFavoriteToggle?.(event, jobDetails)}
                disabled={isFavoriteLoading}
                sx={{ color: isFavorite ? "#f5c518" : "#666" }}>
                {isFavoriteLoading ? (
                  <CircularProgress size={20} />
                ) : isFavorite ? (
                  <StarIcon />
                ) : (
                  <StarBorderIcon />
                )}
              </IconButton>
              <IconButton onClick={onClose}>
                <CloseIcon sx={{ color: "#666" }} />
              </IconButton>
            </Stack>
          </Stack>

          {expiryLabel && (
            <Typography  sx={{color: "#c53030",  fontWeight: 600, px: 2, pt: 1 }}>
              {expiryLabel}
            </Typography>
          )}

          {!isLoading ? (
            <>
              {/* Check if this is an external job */}
              {jobDetails?.isExternal || isExternalJobDetails ? (
                /* External Job UI - matches mobile layout */
                <Box className="main-content-card-list" id="scrollablediv_prodcut" sx={{ pb: 2 }}>
                  {/* Header */}
                  <Stack sx={{ justifyContent: "space-between", alignItems: "flex-start" }} direction="row">
                    {/* Left: title, company, location, chips, publisher */}
                    <Stack sx={{ alignItems: "flex-start", flex: 1, mr: 1 }}>
                      <Typography
                        variant="h6"
                        sx={{ fontWeight: 700, color: "#1a1a1a", lineHeight: 1.3 }}>
                        {jobDetails?.title || jobDetails?.jobTitle}
                      </Typography>
                      {(jobDetails?.companyName || jobDetails?.employerName) && (
                        <Typography variant="body1" sx={{ color: "#666", fontWeight: 500 }}>
                          {jobDetails?.companyName || jobDetails?.employerName}
                        </Typography>
                      )}
                      {jobDetails?.location && (
                        <Stack sx={{ gap: 0.5,  alignItems: "center", mt: 0.5  }} direction="row" >
                          <FmdGoodIcon sx={{ fontSize: 14, color: "#888" }} />
                          <Typography variant="body2" sx={{ color: "text.secondary" }}>
                            {jobDetails.location}
                          </Typography>
                        </Stack>
                      )}
                      {/* Chips: formatted employment type + job post types + trades */}
                      <Stack sx={{ gap: 0.5,  alignItems: "center", mt: 0.5  }} direction="row" flexWrap="wrap" >
                        {employmentType && (
                          <Chip
                            label={formatJobType(employmentType)}
                            sx={{
                              fontSize: 12,
                              height: 20,
                              borderRadius: 5,
                              bgcolor: "#e8edf8",
                              color: BIBlue
                            }}
                          />
                        )}
                        {jobTags?.map((tag, i) => (
                          <Chip
                            label={tag?.typeName || tag?.tradeName || tag?.name || tag?.id || ""}
                            key={i}
                            sx={{ fontSize: 12, height: 20, borderRadius: 5 }}
                          />
                        ))}
                      </Stack>
                      {/* Publisher badge */}
                      {jobDetails?.jobPublisher && (
                        <Stack sx={{ alignItems: "center", mt: 0.75,
                            bgcolor: "#f0f4ff",
                            px: 1,
                            py: 0.5,
                            borderRadius: 1.5,
                            alignSelf: "flex-start" }} direction="row" gap={0.5}>
                          <OpenInNewIcon sx={{ fontSize: 12, color: BIBlue }} />
                          <Typography variant="caption" sx={{ color: BIBlue, fontWeight: 600 }}>
                            {TEXT_VIA} {jobDetails.jobPublisher}
                          </Typography>
                        </Stack>
                      )}
                    </Stack>
                    {/* Right: date + expiry */}
                    <Stack sx={{ gap: 0.5,  alignItems: "flex-end"  }} >
                      <Typography variant="body2" sx={{ color: "text.secondary" }}>
                        {moment(
                          jobDetails?.jobPostedAtDateTime ||
                          jobDetails?.jobPostedDate ||
                          jobDetails?.dateCreated
                        ).format("MMM D, YYYY")}
                      </Typography>
                      {jobDetails?.jobPostExpiryDate && (
                        <Typography variant="caption" sx={{ color: "text.secondary" }}>
                          {TEXT_EXPIRES} {moment(jobDetails.jobPostExpiryDate).format("MMM D")}
                        </Typography>
                      )}
                    </Stack>
                  </Stack>

                  {/* Description */}
                  <Stack sx={{ mt: 1.5 }}>
                    <Typography sx={{ color: "text.secondary" }} variant="body2">
                      {TEXT_DESCRIPTION}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: 
                        !(jobDetails?.jobDescription || jobDetails?.description)
                          ? "textSecondary"
                          : "inherit"
                      ,  whiteSpace: "pre-line", lineHeight: 1.7 }}
                      >
                      {jobDetails?.jobDescription ||
                        jobDetails?.description ||
                        TEXT_NO_DESCRIPTION_AVAILABLE}
                    </Typography>
                  </Stack>

                  {jobDetails?.site?.id && renderSiteSection()}
                  {jobDetails?.companyId ? renderCompanySection() : renderExternalCompanyCard()}
                </Box>
              ) : (
                /* Internal Job UI - Original Design */
                <Box className="main-content-card-list" id="scrollablediv_prodcut">
                  <Stack sx={{ gap: 2,  display: "flex",  alignItems: "center", justifyContent: "space-between"  }} direction="row"  >
                    <Stack sx={{ alignItems: "flex-start" }}>
                      <Typography variant="h6">{jobDetails?.title}</Typography>
                      {Boolean(jobDetails?.companyId) && (
                        <Typography variant="body1">{jobDetails?.companyName}</Typography>
                      )}
                      <Typography sx={{ color: "text.secondary" }} variant="body2">
                        {jobDetails?.location}
                      </Typography>

                      <Stack sx={{ gap: 1,  alignItems: "center", mt: 0.5  }} direction={"row"} flexWrap={"wrap"} >
                        {employmentType && (
                          <Chip
                            label={formatJobType(employmentType)}
                            key="employmentType"
                            sx={{ fontSize: 12, height: 20, borderRadius: 5 }}
                          />
                        )}
                        {jobTags?.map((tag, i) => (
                          <Chip
                            label={tag?.typeName || tag?.tradeName || tag?.name || tag?.id || ""}
                            key={i}
                            sx={{ fontSize: 12, height: 20, borderRadius: 5 }}
                          />
                        ))}
                      </Stack>
                    </Stack>

                    <Stack sx={{ gap: 1,  display: "flex",  alignItems: "flex-end", justifyContent: "top"  }}  >
                      <Typography sx={{ color: "text.secondary" }} variant="body2">
                        {moment(jobDetails?.jobPostedDate).format("MMMM DD, YYYY")}
                      </Typography>
                      {from == "myPostings" ? (
                        jobPostStatus ? (
                          <Chip color="danger" variant="soft" label={TEXT_INACTIVE} />
                        ) : (
                          <Chip color="success" variant="soft" label={TEXT_ACTIVE} />
                        )
                      ) : null}
                    </Stack>
                  </Stack>
                  <Stack>
                    <Stack sx={{ mt: 1 }}>
                      <Typography sx={{ color: "text.secondary" }} variant="body2">
                        {TEXT_DESCRIPTION}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: !jobDetails?.description && "textSecondary",  whiteSpace: "pre-line" }}
                        >
                        {jobDetails?.description || TEXT_NO_DESCRIPTION}
                      </Typography>
                    </Stack>

                    {renderSiteSection()}

                    {renderCompanySection()}
                  </Stack>
                </Box>
              )}

              {/* Action buttons - Sticky at bottom */}
              <Stack
                sx={{
                  position: "sticky",
                  bottom: 0,
                  backgroundColor: "white",
                  zIndex: 10,
                  pt: 2.5,
                  pb: 2,
                  px: { xs: 2, md: 4 },
                  borderTop: "1px solid #eef0f2"
                }}>
                {/* External Job - Apply Now Button */}
                {jobDetails?.isExternal || isExternalJobDetails ? (
                  jobDetails?.applied || jobDetails?.isApplied ? (
                    <Button
                      variant="contained"
                      fullWidth
                      disabled
                      sx={{
                        bgcolor: "#f5f5f5 !important",
                        color: "#9e9e9e !important",
                        py: 1.5,
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 700
                      }}>
                      {TEXT_ALREADY_APPLIED}
                    </Button>
                  ) : showExternalApplyConfirmation ? (
                    <Stack spacing={2}>
                      <Typography
                        variant="body2"
                        sx={{ textAlign: "center", fontWeight: 600, color: "#444" }}>
                        {TEXT_DID_YOU_APPLY}
                      </Typography>
                      <Stack direction="row" spacing={2}>
                        <Button
                          variant="contained"
                          fullWidth
                          onClick={onSaveExternalJob}
                          disabled={saveLoading}
                          sx={{
                            bgcolor: "#1a365d",
                            color: "#fff",
                            py: 1.2,
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: 700,
                            "&:hover": { bgcolor: "#102a43" }
                          }}>
                          {saveLoading ? (
                            <CircularProgress size={24} sx={{ color: "white" }} />
                          ) : (
                            TEXT_YES_I_APPLIED
                          )}
                        </Button>
                        <Button
                          variant="outlined"
                          fullWidth
                          onClick={() => setShowExternalApplyConfirmation(false)}
                          disabled={saveLoading}
                          sx={{
                            color: "#1a365d",
                            borderColor: "#1a365d",
                            py: 1.2,
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: 700,
                            "&:hover": { borderColor: "#102a43", bgcolor: "rgba(26, 54, 93, 0.04)" }
                          }}>
                          {TEXT_NO}
                        </Button>
                      </Stack>
                    </Stack>
                  ) : (
                    <Button
                      variant="contained"
                      fullWidth
                      endIcon={<OpenInNewIcon />}
                      onClick={() => {
                        const url = jobDetails?.receiveApplicantLink;
                        if (url) {
                          window.open(url, "_blank");
                          setTimeout(() => {
                            setShowExternalApplyConfirmation(true);
                          }, 1000);
                        }
                      }}
                      sx={{
                        bgcolor: "#1a365d",
                        color: "#fff",
                        py: 1.5,
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 700,
                        boxShadow: "0 4px 14px rgba(26, 54, 93, 0.25)",
                        "&:hover": {
                          bgcolor: "#102a43",
                          boxShadow: "0 6px 20px rgba(26, 54, 93, 0.3)"
                        }
                      }}>
                      {TEXT_APPLY_NOW}
                    </Button>
                  )
                ) : from === "myPostings" ? (
                  <Stack sx={{ gap: 2,  justifyContent: "space-between", alignItems: "center"  }} direction={"row"} >
                    <Button
                      variant="contained"
                      onClick={() => setDeleteConfirmationOpen(true)}
                      sx={{
                        display: "flex",
                        flex: 1,
                        backgroundColor: "lightgray",
                        color: "black",
                        boxShadow: "none"
                      }}>
                      {TEXT_DELETE}
                    </Button>
                    <Button
                      variant="contained"
                      onClick={onRepostClick}
                      sx={{
                        display: "flex",
                        flex: 1,
                        backgroundColor: "lightgray",
                        color: "black",
                        boxShadow: "none",
                        gap: 2
                      }}
                      disabled={isRepostLoading}>
                      {isRepostLoading ? (
                        <CircularProgress sx={{ color: "black" }} size={22} />
                      ) : null}
                      {TEXT_REPOST}
                    </Button>
                  </Stack>
                ) : (
                  <>
                    {jobDetails?.isApplied ? (
                      <Button variant="contained" disabled>
                        {TEXT_APPLIED}
                      </Button>
                    ) : applyLoader ? (
                      <Button variant="contained">
                        <CircularProgress sx={{ color: "white" }} size={22} />
                      </Button>
                    ) : jobDetails?.receiveApplicantBy === "WEBSITE" ? (
                      <>
                        {showConfirmationForWebiste && (
                          <Stack sx={{ justifyContent: "space-between", alignItems: "center", mb: 1,
                              backgroundColor: lightenHexColor(BIBlue, 90),
                              p: 1,
                              borderRadius: 1 }} direction={"row"}>
                            <Typography variant="body2">{TEXT_DID_YOU_APPLY}</Typography>
                            <Stack sx={{ gap: 2,  justifyContent: "center", alignItems: "center"  }} direction={"row"} >
                              <Button
                                variant="outlined"
                                sx={{ backgroundColor: "white", fontSize: 12 }}
                                onClick={onYesClick}>
                                {TEXT_YES}
                              </Button>
                              <Button
                                variant="outlined"
                                sx={{ backgroundColor: "white", fontSize: 12 }}
                                onClick={() => {
                                  setShowConfirmationForWebiste(false);
                                }}>
                                {TEXT_NO}
                              </Button>
                            </Stack>
                          </Stack>
                        )}
                        <Button
                          variant="contained"
                          endIcon={<LoginIcon />}
                          onClick={onApplyOnWebsite}>
                          {TEXT_APPLY_ON_WEBSITE}
                        </Button>
                      </>
                    ) : (
                      <Button variant="contained" onClick={onApplyClick}>
                        {TEXT_APPLY}
                      </Button>
                    )}
                  </>
                )}
              </Stack>
            </>
          ) : (
            <Stack sx={{ height: "400px", alignItems: "center", justifyContent: "center" }}>
              <Loader />
            </Stack>
          )}
        </Box>
      </Modal>

      {deleteConfimationOpen && (
        <DeleteConfirmation
          open={deleteConfimationOpen}
          onClose={() => setDeleteConfirmationOpen(false)}
          headerText={TEXT_DELETE_JOB_POSTING}
          secondaryText={TEXT_DELETE_JOB_POST_CONFIRM}
          onBadgeClick={() => {
            // Handle delete action here
            setDeleteConfirmationOpen(false);
            onDeleteClick();
          }}
          actionBtnText={TEXT_YES}
        />
      )}

      <ResumeList
        open={showResumeListModal}
        setOpenResumeListModal={setShowResumeListModal}
        applyJobData={jobDetails}
        onJobApplied={onJobAppliedSucess}
        from="jobPostings"
      />
    </>
  );
};

export default ViewJobPosting;

